// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ProfileNavigation-styles--item--zed6Q {
  margin-top: 10px;
  margin-bottom: 10px;
}
.src-components-ProfileNavigation-styles--item--zed6Q:first-child {
    margin-top: -5px;
  }
.src-components-ProfileNavigation-styles--item--zed6Q:last-child {
    margin-bottom: -5px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/ProfileNavigation/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AASrB;AAPE;IACE,gBAAgB;EAClB;AAEA;IACE,mBAAmB;EACrB","sourcesContent":[".item {\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  &:first-child {\n    margin-top: -5px;\n  }\n\n  &:last-child {\n    margin-bottom: -5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `src-components-ProfileNavigation-styles--item--zed6Q`
};
module.exports = ___CSS_LOADER_EXPORT___;
